export default {
  'sendticket.sendticket': 'リクエストの送信',
  'sendticket.sentsuccessfully': 'リクエストが送信されました',
  'sendticket.replytickets': 'リクエストに返信',
  'sendticket.you': 'あなた',
  'sendticket.operator': 'オペレーター',
  'sendticket.reply': '返信',
  'sendticket.createdat': '作成日',
  'sendticket.laststatus': '最終ステータス',
  'sendticket.ticketid': 'リクエストID ',
  'sendticket.closeticketquestion': 'リクエストに回答がありましたか？',
  'sendticket.closeticket': 'はい、リクエストを閉じます',
  'sendticket.notcloseticket': 'いいえ',
  'sendticket.closedsuccessfully': 'リクエストが閉じられました',
  'sendticket.downloadfile': 'ファイルのダウンロード',
  'sendticket.subject': '件名',
  'sendticket.ticketId': 'リクエストID ',
  'sendticket.sender': '差出人',
  'sendticket.yes': 'はい、回答がありました',
  'sendticket.no': 'まだです',
  'sendticket.pleaseTryAgain': 'もう一度試してください',
  'sendticket.daysago': '数日前',
  'sendticket.hoursago': '時間前',
  'sendticket.minutesago': '数分前',
  'sendticket.today': '( 今日 )',
  'sendticket.yesterday': '( 昨日 )',
  'sendticket.justnow': 'ちょうど今',
};
